import { createFileRoute } from "@tanstack/react-router";

import { PageHero, Prose } from "@/components/site/Page";
import { SubscribeForm } from "@/components/site/SubscribeForm";
import { seoLinks, ogImage } from "@/lib/seo";

const TITLE = "Subscribe to our newsletter and blog | SIS Estepona";
const DESCRIPTION =
  "Get the school newsletter and new blog posts from Swedish International School in Estepona straight to your inbox.";

export const Route = createFileRoute("/en/subscribe")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "en_GB" },
      ...ogImage(),
    ],
    links: seoLinks("/en/subscribe"),
  }),
  component: SubscribePage,
});

function SubscribePage() {
  return (
    <>
      <PageHero
        eyebrow="Subscribe"
        title="Stay up to date with the school"
        intro="Newsletters and blog posts about teaching, school life and practical matters for families on the Costa del Sol."
      />

      <div className="mx-auto max-w-3xl px-5 py-10 sm:py-14">
        <SubscribeForm locale="en" source="/en/subscribe" />
      </div>

      <Prose>
        <h2>What you get</h2>
        <p>
          The newsletter is sent a few times each term and gathers what is coming up: key dates, news
          from the school and things that are useful to know before starting. If you choose blog posts,
          you receive an email whenever we publish a new article.
        </p>
        <h2>How we handle your address</h2>
        <p>
          Your email address is stored with us and used only for the emails you selected. We never sell
          or share the list. Every email contains a link where you can change your choices or cancel the
          subscription entirely, without contacting us.
        </p>
      </Prose>
    </>
  );
}
